module.exports = __webpack_public_path__ + "img/avatar6.08171c57.png";